/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Shows that an employee has accepted a version of a document that was assigned to them
 * @export
 * @interface DocumentAcceptance
 */
export interface DocumentAcceptance {
    /**
     * 
     * @type {number}
     * @memberof DocumentAcceptance
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentAcceptance
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentAcceptance
     */
    documentVersionId: number;
    /**
     * The document ID (derived from the version)
     * @type {number}
     * @memberof DocumentAcceptance
     */
    documentId: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentAcceptance
     */
    employeeId: number;
    /**
     * 
     * @type {Date}
     * @memberof DocumentAcceptance
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the DocumentAcceptance interface.
 */
export function instanceOfDocumentAcceptance(value: object): value is DocumentAcceptance {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('documentVersionId' in value) || value['documentVersionId'] === undefined) return false;
    if (!('documentId' in value) || value['documentId'] === undefined) return false;
    if (!('employeeId' in value) || value['employeeId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function DocumentAcceptanceFromJSON(json: any): DocumentAcceptance {
    return DocumentAcceptanceFromJSONTyped(json, false);
}

export function DocumentAcceptanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentAcceptance {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'documentVersionId': json['documentVersionId'],
        'documentId': json['documentId'],
        'employeeId': json['employeeId'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

  export function DocumentAcceptanceToJSON(json: any): DocumentAcceptance {
      return DocumentAcceptanceToJSONTyped(json, false);
  }

  export function DocumentAcceptanceToJSONTyped(value?: DocumentAcceptance | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'documentVersionId': value['documentVersionId'],
        'documentId': value['documentId'],
        'employeeId': value['employeeId'],
        'createdAt': ((value['createdAt']).toISOString()),
    };
}

